export class xlNoReq{
    xlNo?: string;
    type?:string;
    stockId?:number;

    constructor( xlNo?:string,type?:string,stockId?:number){
        this.xlNo = xlNo
        this.type = type
        this.stockId = stockId
    }
}